import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IVideoPlaylist } from './VideoPlaylist.Contract';

import styles from './add-playlist.module.less';

@Component({
	selector: 'add-playlist',
	templateUrl: './AddPlaylist.Component.html'
})

export class AddPlaylistComponent implements OnInit {
	@Input() public isSaving: boolean;

	@Output() public onCancel: EventEmitter<any> = new EventEmitter();
	@Output() public onSave: EventEmitter<any> = new EventEmitter();

	public readonly styles = styles;
	public playlist: IVideoPlaylist;

	public ngOnInit(): void {
		this.initializePlaylist();
	}

	public createPlaylist(): void {
		this.onSave.emit({
			playlist: this.playlist
		});
	}

	public cancelCreatePlaylist(): void {
		this.initializePlaylist();
		this.onCancel.emit();
	}

	private initializePlaylist(): void {
		this.playlist = { name: undefined, isSelected: true, videoIds: [] };
	}
}
